import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState, useEffect } from "react";
import { Uploader } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Loader, httpClient, StatusMessage } from "../index";
function Dropzone(props) {
    const { endpoint, fileType, generateMessages, setResponse } = props;
    const [fileList, setFileList] = useState([]);
    const [validate, setValidate] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [messages, setMessages] = useState([]);
    const [fail, setFail] = useState(false);
    useEffect(() => {
        if (fileList.length > 0) {
            setIsLoading(true);
            setHasLoaded(false);
            setMessages([]);
            validateFile();
            setFail(false);
        }
    }, [validate]);
    const validateFile = () => {
        const formData = new FormData();
        formData.set("file", fileList[fileList.length - 1].blobFile, fileList[fileList.length - 1].name);
        httpClient()
            .post("/" + endpoint, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then((res) => {
            if (setResponse) {
                setResponse(res);
            }
            setIsLoading(false);
            setHasLoaded(true);
            setMessages(generateMessages(res));
        })
            .catch((error) => {
            setIsLoading(false);
            setFail(true);
            setFileList([]);
            console.error(error);
        });
    };
    const WaitingUpload = (props) => {
        return (_jsxs("div", { className: "dropzone-container", children: [_jsx(FontAwesomeIcon, { className: "file-upload", icon: faFileArrowUp, size: "8x" }), _jsx("p", { children: props.message }), fileList.length > 0 ? (_jsx("p", { className: "file-name", children: String(fileList[fileList.length - 1].name) })) : (_jsx("p", {}))] }));
    };
    return (_jsxs("div", { className: "tol-dropzone", children: [_jsx(Uploader, { action: "temp-error-please-ignore", draggable: true, accept: fileType, onChange: setFileList, fileListVisible: false, onUpload: () => {
                    setValidate(!validate);
                }, children: _jsx("div", { children: isLoading ? (_jsx("div", { className: "dropzone-container", children: _jsx(Loader, {}) })) : (_jsx("div", { children: fail ? (_jsx(WaitingUpload, { message: "Unexpected error, please try again" })) : (_jsx(WaitingUpload, { message: "Click or drag file to this area to upload" })) })) }) }), hasLoaded ? (_jsx("div", { className: "mt-3", children: messages.map((message, index) => {
                    return (_jsx(StatusMessage, { status: message.type, message: message.message }, index));
                }) })) : (_jsx(_Fragment, {}))] }));
}
export default Dropzone;
